export default () => (
  <svg width="17" height="20" fill="none" viewBox="0 0 17 20">
    <g clipPath="url(#svg--apple-empty--clip)">
      <path
        fill="#D7D7D7"
        d="M9.31 1.72a4.2 4.2 0 0 0-1.07 1.82A4.75 4.75 0 0 0 5.4 1.67a.69.69 0 0 0-.79.59c-.06.38.18.76.55.83.12.02 2.8.59 2.8 4.17 0 .4.31.72.69.72a.7.7 0 0 0 .69-.72c0-.7-.1-1.3-.23-1.85.72.16 1.71-.25 2.6-1.17C12.89 3 13.36 0 13.36 0S10.49.49 9.3 1.72Z"
      />
      <path
        fill="#A8A8AB"
        d="M11 6.32c-.9 0-1.75.5-2.5.82-.75-.31-1.6-.82-2.5-.82-3.04 0-5.5 1.62-5.5 5.92C.5 16.53 2.96 20 6 20c.9 0 1.75-.3 2.5-.84.75.54 1.6.84 2.49.84 3.04 0 5.5-3.47 5.5-7.76 0-4.3-2.46-5.92-5.5-5.92Z"
      />
    </g>
    <defs>
      <clipPath id="svg--apple-empty--clip">
        <path fill="#fff" d="M.5 0h16v20H.5z" />
      </clipPath>
    </defs>
  </svg>
);
